// Central cosmetic catalog. Both the shop and gacha pick items from
// this list; rendering code in main.ts uses it to turn an equipped id
// into a concrete visual (hat sprite, pet color, etc).

export type CosmeticSlot = 'hat' | 'skin' | 'mimic' | 'pet' | 'trail';

export type CosmeticDef = {
  id: string;
  name: string;
  slot: CosmeticSlot;
  icon: string;     // emoji used in UI and as the hat sprite face
  color: string;    // hex, used for pet tint / hat accent / shop card border
  source: 'shop' | 'gacha';
  price?: number;   // shop only — Special Points
  rarity?: 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';
  gachaWeight?: number;  // gacha only
};

export const COSMETICS: ReadonlyArray<CosmeticDef> = [
  // ---- Shop (Special Points) ----
  { id: 'skin_shadow',  name: 'Shadow Ninja',    slot: 'skin',  icon: '🥷', color: '#334155', source: 'shop', price: 25 },
  { id: 'skin_neon',    name: 'Neon Chad', slot: 'skin',  icon: '💃', color: '#f472b6', source: 'shop', price: 30 },
  { id: 'hat_crown',    name: 'Golden Crown',    slot: 'hat',   icon: '👑', color: '#fbbf24', source: 'shop', price: 50 },
  { id: 'hat_band',     name: 'Sweatband',       slot: 'hat',   icon: '🎯', color: '#60a5fa', source: 'shop', price: 12 },
  { id: 'mimic_bush',   name: 'Mimic Bush',      slot: 'mimic', icon: '🌳', color: '#22c55e', source: 'shop', price: 40 },
  { id: 'mimic_crate',  name: 'Mimic Crate',     slot: 'mimic', icon: '📦', color: '#a16207', source: 'shop', price: 35 },

  // ---- Gacha (Crystals) ----
  { id: 'pet_dust',    name: 'Dust Bunny',    slot: 'pet',   icon: '🐰', color: '#e5e7eb', source: 'gacha', rarity: 'common',    gachaWeight: 55 },
  { id: 'hat_beanie',  name: 'Pixel Beanie',  slot: 'hat',   icon: '🧢', color: '#16a34a', source: 'gacha', rarity: 'common',    gachaWeight: 55 },
  { id: 'trail_neon',  name: 'Neon Trail',    slot: 'trail', icon: '✨', color: '#22c55e', source: 'gacha', rarity: 'uncommon',  gachaWeight: 25 },
  { id: 'pet_kitsune', name: 'Kitsune Spark', slot: 'pet',   icon: '🦊', color: '#fb923c', source: 'gacha', rarity: 'uncommon',  gachaWeight: 25 },
  { id: 'cape_shadow', name: 'Shadow Cape',   slot: 'skin',  icon: '🧥', color: '#3b82f6', source: 'gacha', rarity: 'rare',      gachaWeight: 12 },
  { id: 'hat_halo',    name: 'Hero Halo',     slot: 'hat',   icon: '😇', color: '#fde047', source: 'gacha', rarity: 'rare',      gachaWeight: 12 },
  { id: 'hat_visor',   name: 'Neon Visor',    slot: 'hat',   icon: '🕶️', color: '#a855f7', source: 'gacha', rarity: 'epic',      gachaWeight: 6  },
  { id: 'trail_gold',  name: 'Golden Aura',   slot: 'trail', icon: '🌟', color: '#f59e0b', source: 'gacha', rarity: 'legendary', gachaWeight: 2  },
];

const BY_ID: Map<string, CosmeticDef> = new Map(COSMETICS.map((c) => [c.id, c]));

export function getCosmetic(id: string): CosmeticDef | null {
  return BY_ID.get(id) ?? null;
}

export function shopItems(): CosmeticDef[] {
  return COSMETICS.filter((c) => c.source === 'shop');
}

export function gachaPool(): CosmeticDef[] {
  return COSMETICS.filter((c) => c.source === 'gacha');
}

export const SLOT_LABELS: Record<CosmeticSlot, string> = {
  hat: 'HAT',
  skin: 'SKIN',
  mimic: 'MIMIC',
  pet: 'PET',
  trail: 'TRAIL',
};
